import { api } from "./configs/axiosConfigs"

export const SubCategoryAPI = {
    
    getSubCategories: async (data:any) => {
        const response = await api.get(
            '/subcategory', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSubcategoriesByCompany: async (data:any) => {
        const response = await api.get(
            '/subcategory/listByCompany', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSubcategoriesDuplicated: async (data:any) => {
        const response = await api.get(
            '/subcategory/listDuplicated', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getReviewData: async (data:any) => {
        const response = await api.get(
            '/subcategory/reviewData', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSubcategoriesWithProducts: async (data:any) => {
        const response = await api.get(
            '/subcategory/listWithProducts', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    getSubcategoriesByCategory: async (data:any) => {
        const response = await api.get(
            '/subcategory/listByCategory', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createSubCategory: async (data: any) => {
        const response = await api.post(
            '/subcategory/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },

    unifyDuplicated: async (data: any) => {
        const response = await api.post(
            '/subcategory/unifyDuplicated', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editSubCategory: async (idsubcategory: number, data: any) => {
        const response = await api.patch(
            `/subcategory/${idsubcategory}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
    
    deleteSubCategory: async (idsubcategory: number) => {
        const response = await api.delete(
            `/subcategory/${idsubcategory}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}